module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide carousel-fade",
    class: _vm.$route.name,
    attrs: {
      "id": "carousel-slider",
      "data-ride": "carousel",
      "data-interval": "false"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "carousel-preload"
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/loading.gif"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_vm._l((_vm.filterBy(_vm.capas, _vm.filter, 'section')), function(capa) {
    return _c('div', {
      key: _vm.$route.name,
      staticClass: "item active lazy-load item-capa",
      style: ({
        'background-image': 'url(' + _vm.api + capa.img + ')'
      })
    }, [_c('div', {
      staticClass: "item-content",
      class: capa.color
    }, [_c('div', {
      staticClass: "item-content--icon-wrapper"
    }, [(capa.color === 'white') ? _c('img', {
      staticClass: "item-content--icon",
      attrs: {
        "src": "static/imgs/icon.svg"
      }
    }) : _vm._e(), _vm._v(" "), (capa.color === 'black') ? _c('img', {
      staticClass: "item-content--icon",
      attrs: {
        "src": "static/imgs/icon-black.svg"
      }
    }) : _vm._e()]), _vm._v(" "), _c('h1', {
      staticClass: "item-content--title"
    }, [_vm._v(_vm._s(capa.title))]), _vm._v(" "), (capa.desc) ? _c('h3', {
      staticClass: "item-content--desc"
    }, [_vm._v(_vm._s(capa.desc))]) : _vm._e(), _vm._v(" "), (capa.longtext) ? _c('h3', {
      staticClass: "item-content--longtext",
      domProps: {
        "innerHTML": _vm._s(capa.longtext)
      }
    }) : _vm._e(), _vm._v(" "), (capa.shorttext) ? _c('h3', {
      staticClass: "item-content--shorttext",
      domProps: {
        "innerHTML": _vm._s(capa.shorttext)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-content--counter"
    })])])
  }), _vm._v(" "), _vm._l((_vm.filterBy(_vm.slides, _vm.filter, 'section')), function(slide) {
    return _c('div', {
      key: _vm.$route.name,
      staticClass: "item lazy-load item-slide",
      attrs: {
        "data-src": _vm.api + slide.img
      }
    }, [_c('div', {
      staticClass: "item-content",
      class: slide.color
    }, [_c('div', {
      staticClass: "item-content--icon-wrapper"
    }, [(slide.color === 'white') ? _c('img', {
      staticClass: "item-content--icon",
      attrs: {
        "src": "static/imgs/icon.svg"
      }
    }) : _vm._e(), _vm._v(" "), (slide.color === 'black') ? _c('img', {
      staticClass: "item-content--icon",
      attrs: {
        "src": "static/imgs/icon-black.svg"
      }
    }) : _vm._e()]), _vm._v(" "), _c('h1', {
      staticClass: "item-content--title"
    }, [_vm._v(_vm._s(slide.title))]), _vm._v(" "), (slide.desc) ? _c('h3', {
      staticClass: "item-content--desc"
    }, [_vm._v(_vm._s(slide.desc))]) : _vm._e(), _vm._v(" "), (slide.longtext) ? _c('h3', {
      staticClass: "item-content--longtext",
      domProps: {
        "innerHTML": _vm._s(slide.longtext)
      }
    }) : _vm._e(), _vm._v(" "), (slide.shorttext) ? _c('div', {
      staticClass: "item-content--shorttext-wrapper"
    }, [(slide.shorttext) ? _c('h3', {
      staticClass: "item-content--shorttext",
      domProps: {
        "innerHTML": _vm._s(slide.shorttext)
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (slide.model) ? _c('img', {
      staticClass: "item-content--model",
      attrs: {
        "src": _vm.api + slide.model
      }
    }) : _vm._e(), _vm._v(" "), (slide.boxes[0] !== '') ? _c('div', {
      staticClass: "item-content--boxes"
    }, _vm._l((slide.boxes), function(box) {
      return (slide.boxes) ? _c('lightbox', {
        key: box,
        staticClass: "item-content--box",
        style: ({
          'background-image': 'url(' + _vm.api + box + ')'
        }),
        attrs: {
          "src": _vm.api + box
        }
      }, [(slide.boxes) ? _c('img', {
        attrs: {
          "width": "100px",
          "src": _vm.api + box
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-content--counter"
    })])])
  })], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "carousel-control left",
    attrs: {
      "href": "#carousel-slider",
      "data-slide": "prev"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/icons/prev.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "carousel-control right",
    attrs: {
      "href": "#carousel-slider",
      "data-slide": "next"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/icons/next.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40824296"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 67
// module chunks = 1